// extracted by mini-css-extract-plugin
module.exports = {"container":"_1410bfd27b--container--r54xr","title":"_1410bfd27b--title--uYSop","description":"_1410bfd27b--description--GQZr4"};